import { render, staticRenderFns } from "./TravelDetails.vue?vue&type=template&id=300d79dd"
import script from "./TravelDetails.vue?vue&type=script&lang=js"
export * from "./TravelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports